<!--<app-main-loading/>-->

<div class="main-container">
    <app-section [sticky]="true">
        <app-title-page/>
    </app-section>
    <app-section #aboutPage>
        <app-about-page/>
    </app-section>
    <app-section #thanksPage>
        <app-thanks-page/>
    </app-section>
    <app-section #contactsPage [sticky]="true">
        <app-contacts-page/>
    </app-section>
    <app-section >
        <div #footer>
            <app-footer/>
        </div>
    </app-section>
</div>
